import { Injectable } from "@angular/core";
import { BehaviorSubject, of } from "rxjs";
import * as utils from '../../utils/utility-functions';
import { UserService } from "../user.service";
import { AngularFirestore, AngularFirestoreCollection } from "@angular/fire/compat/firestore";
import * as moment from "moment-timezone";
import { AdminNote } from "src/app/models/forms/admin-note.model";
import { switchMap } from "rxjs/operators";
import { AngularFireAuth } from "@angular/fire/compat/auth";

@Injectable({
    providedIn: 'root',
})
export class AdminNotesService {
    private firebaseAdminNotesCollection: AngularFirestoreCollection;
    private currentUsername: any;

    private adminNotes = new BehaviorSubject([]);
    currentAdminNotes = this.adminNotes.asObservable();

    constructor(
        private userService: UserService,
        private angularFirestore: AngularFirestore,
        private afAuth: AngularFireAuth) {
        this.currentUsername = this.userService.currentUserValue.email;
    }

    async getAdminNotes(id: string) {
        try {
            let adminNotes = [];

            if (this.firebaseAdminNotesCollection == null) {
                this.firebaseAdminNotesCollection = this.angularFirestore.collection('AdminNotes');
            }

            await this.firebaseAdminNotesCollection.ref
                .where('appointment_id', '==', id)
                .orderBy('created_at', 'desc')
                .get()
                .then(querySnapshot => {
                    querySnapshot.forEach(doc => {
                        const docData = {
                            id: doc.id,
                            ...doc.data()
                        }
                        adminNotes.push(docData)
                    });
                }).catch(err => console.log("getAdminNotes query 1 error: " + err));

            this.updateAdminNotes(adminNotes);
            return adminNotes;
        } catch (error) {
            console.log(error);
        }
    }

    getAdminNotesAsync(id: string) {
        return this.afAuth.authState.pipe(
            switchMap(user => {
                if (user) {
                    return this.angularFirestore.collection<AdminNote>('AdminNotes', ref => ref
                        .where('appointment_id', '==', id)
                        .orderBy('created_at', 'desc'))
                        .valueChanges({ idField: 'id' });
                } else {
                    return of(null);
                }
            })
        );
    }

    async createAdminNote(appointment_id: string, message: string) {
        try {
            if (this.firebaseAdminNotesCollection == null) {
                this.firebaseAdminNotesCollection = this.angularFirestore.collection('AdminNotes');
            }

            let newAdminNoteObject: any = {
                appointment_id: appointment_id,
                message: message,
                username: this.currentUsername,
                created_at: Number(moment().format('x'))
            }

            await this.firebaseAdminNotesCollection.ref
                .add(JSON.parse(JSON.stringify(newAdminNoteObject)))
                .then(function (docRef) {
                    newAdminNoteObject.id = docRef.id
                })
                .catch(err => console.log("getAdminNotes query 1 error: " + err));

            this.addAdminNote(newAdminNoteObject);
        } catch (error) {
            console.log(error);
        }
    }

    updateAdminNotes(adminNotesResults: any) {
        let adminNoteArray = [];
        adminNotesResults.forEach(note => {
            const newLog = utils.createAdminNote(note);
            adminNoteArray.push(newLog);
        });
        this.adminNotes.next(adminNoteArray);
    }

    addAdminNote(adminNote) {
        let currentAdminNotes = this.adminNotes.value;
        const newNote = utils.createAdminNote(adminNote);
        currentAdminNotes.unshift(newNote);
        this.adminNotes.next(currentAdminNotes);
    }
}